import { FindJobsButton } from './find-jobs-button'
import { FindTalentButton } from './find-talent-button'

export const CtaBlock = () => (
  <div className='border-t border-t-neutral-00 py-10'>
    <h2 className='text-center text-2xl font-semibold lg:text-4xl'>Where Top Talent Meets Great Opportunities</h2>
    <div className='mt-6 flex flex-col items-center justify-center gap-4 lg:flex-row'>
      <FindJobsButton />
      <FindTalentButton />
    </div>
  </div>
)
